import {Enum} from 'enumify'

class WeatherIconType extends Enum {}
WeatherIconType.initEnum({
  CLEAR_DAY: {
    src: 'clearday.png',
    apiName: 'clear-day'
  },
  CLEAR_NIGHT: {
    src: 'clearnight.png',
    apiName: 'clear-night'
  },
  RAIN: {
    src: 'rain.png',
    apiName: 'rain'
  },
  SNOW: {
    src: 'snow.png',
    apiName: 'snow'
  },
  SLEET: {
    src: 'sleet.png',
    apiName: 'sleet'
  },
  WIND: {
    src: 'wind.png',
    apiName: 'wind'
  },
  FOG: {
    src: 'fog.png',
    apiName: 'fog'
  },
  CLOUDY: {
    src: 'cloudy.png',
    apiName: 'cloudy'
  },
  PARTY_CLOUDY_DAY: {
    src: 'partlycloudyday.png',
    apiName: 'partly-cloudy-day'
  },
  PARTY_CLOUDY_NIGHT: {
    src: 'partlycloudynight.png',
    apiName: 'partly-cloudy-night'
  }
})

export function getWeatherIconType (apiName) {
  for (const type of WeatherIconType.enumValues) {
    if (type.apiName === apiName) {
      return type
    }
  }
}

export default WeatherIconType



// WEBPACK FOOTER //
// ./src/components/shared/enums/weather-icon-type.js